module.exports = __webpack_public_path__ + "img/play-icon.1f1e46b.png";